export interface CalendarDto {
    compCd: string;
    systemDay: string;
    holidayYn: string;
    holidayName: string;
    holidayType: string;
    remark: string;
    insertDt: string;
    insertUser: string;
    insertForm: string;
    updateDt: string;
    updateUser: string;
    updateForm: string;
}

export const defaultCalendarDto: CalendarDto = {
    compCd: '',
    systemDay: '',
    holidayYn: 'Y',
    holidayName: '',
    holidayType: '',
    remark: '',
    insertDt: '',
    insertUser: '',
    insertForm: '',
    updateDt: '',
    updateUser: '',
    updateForm: '',
}

export type CalendarViewType = 'month' | 'week' | 'day';

export interface EventCategory {
    id: string;
    name: string;
    color: string;
}

export const defaultEventCategories: EventCategory[] = [
    { id: 'general', name: '일반', color: '#3826A6' },
    { id: 'holiday', name: '휴일', color: '#EF4444' },
    { id: 'work', name: '업무', color: '#F59E0B' },
]; 